import React, { useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core';

import GridItem from 'components/MaterialKit/Grid/GridItem.js';

import Card from 'components/MaterialKit/Card/Card.js';
import CardBody from 'components/MaterialKit/Card/CardBody.js';
import CardHeader from 'components/MaterialKit/Card/CardHeader.js';

import styles from 'assets/jss/material-kit-react/views/loginPage.js';

// import EnhancedManageAccount from './EnhancedManageAccount';
// import { useHistory } from "react-router-dom";
// import ForgotPassword from '../ForgotPassword/ForgotPassword';
//import { useSelector, shallowEqual } from "react-redux";

// import UpdatePassword from '../UpdatePassword/UpdatePassword';
import Loader from 'components/Loader/Loader';
import NavPills from 'components/MaterialKit/NavPills/NavPills';
import EnhancedReportPostForm from './ReportPost/EnhancedReportPostForm';
import { ReportOutlined, StarsOutlined } from '@material-ui/icons';
import EnhancedRatePostForm from './RatePost/EnhancedRatePostForm';

const useStyles = makeStyles(styles);

export default function PostActions(props) {
  const [cardAnimaton, setCardAnimation] = useState('cardHidden');
  setTimeout(function () {
    setCardAnimation('');
  }, 700);
  const classes = useStyles();
  const { setOpenModal } = props;

  return (
    <>
      <GridItem xs={12} sm={12} md={4} style={{ margin: '3rem auto' }}>
        <Card className={classes[cardAnimaton]}>
          <CardHeader color='black' className={classes.cardHeader}>
            <h3>Post Actions</h3>
          </CardHeader>
          <CardBody style={{ overflow: 'scroll' }}>
            <NavPills
              color='warning'
              alignCenter
              tabs={[
                {
                  tabButton: 'Rate Post',
                  tabIcon: StarsOutlined,
                  tabContent: (
                    <EnhancedRatePostForm setOpenModal={setOpenModal} />
                  ),
                },
                {
                  tabButton: 'Report Post',
                  tabIcon: ReportOutlined,
                  tabContent: (
                    <EnhancedReportPostForm setOpenModal={setOpenModal} />
                  ),
                },
              ]}
            />
          </CardBody>
          {/* <EnhancedManageAccount setOpenModal={setOpenModal} /> */}
        </Card>
      </GridItem>
    </>
  );
}
